/**
 * 🗺️ 福氣好門 GIS | 核心地圖初始化模組 (v15.0.0)
 * 職責：負責 Leaflet 實例建立與底圖代理加載。
 */

import { attachTileAutoReload } from '../utils/tile-auto-reload.js';
import { attachMyLocationControl } from '../utils/my-location-control.js';
import { attachZoomLevelControl } from '../utils/zoom-level-control.js';

export function initSovereignMap(containerId) {
    console.log("🚀 [SOVEREIGN-MAP] Initializing core components...");

    // 📡 主權底圖配置 (全數經過後端代理)
    const tilesConfig = {
        carto: {
            url: '/api/tiles/carto/{z}/{x}/{y}.png?v=17.0.796',
            attr: '&copy; <a href="https://carto.com/">CARTO</a> | Sovereign Proxy'
        },
        osm: {
            url: '/api/tiles/standard/{z}/{x}/{y}.png?v=17.0.796',
            attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> | Sovereign Proxy'
        },
        transport: {
            url: '/api/tiles/transport/{z}/{x}/{y}.png?v=17.0.796',
            attr: '&copy; <a href="https://www.thunderforest.com/">Thunderforest</a> | Sovereign Proxy'
        }
    };

    // 1. 初始化地圖中心 (預設台灣)
    const map = L.map(containerId, {
        center: [23.8, 120.9],
        zoom: 8,
        zoomControl: false,
        attributionControl: true,
        preferCanvas: true
    });

    // 2. 建立圖層實例（僅同源代理；直連 CDN 無 key 會烙 API KEY REQUIRED）
    const cartoLayer = L.tileLayer(tilesConfig.carto.url, {
        attribution: tilesConfig.carto.attr,
        maxZoom: 20,
        subdomains: 'abcd'
    }).addTo(map);

    const osmLayer = L.tileLayer(tilesConfig.osm.url, {
        attribution: tilesConfig.osm.attr
    });

    const transportLayer = L.tileLayer(tilesConfig.transport.url, {
        attribution: tilesConfig.transport.attr
    });

    attachTileAutoReload(cartoLayer, map);
    attachTileAutoReload(osmLayer, map);
    attachTileAutoReload(transportLayer, map);

    // 3. 圖層切換控制項
    const baseMaps = {
        '淺色街道圖 (Carto Light)': cartoLayer,
        '標準街道圖 (OSM)': osmLayer,
        '運輸路網圖 (Transport)': transportLayer
    };

    L.control.layers(baseMaps, null, {
        collapsed: false,
        position: 'topright'
    }).addTo(map);

    attachZoomLevelControl(map);
    attachMyLocationControl(map);

    return map;
}
